import { API_BASE } from './config';

export async function registerUser({ first_name, last_name, email, password }) {
  const res = await fetch(`${API_BASE}/api/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ first_name, last_name, email, password }),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || error.error || 'Registration failed');
  }

  return res.json();
}

export async function loginUser({ email, password }) {
  const res = await fetch(`${API_BASE}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || error.error || 'Login failed');
  }

  return res.json();
}

// Google OAuth MUST be a full redirect (not fetch)
export function startGoogleLogin() {
  window.location.href = `${API_BASE}/api/auth/google`;
}

// Hydrate logged-in user using cookie auth
export async function getMe() {
  const res = await fetch(`${API_BASE}/api/auth/me`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!res.ok) {
    return null;
  }

  return res.json();
}